import { Tooltip, Typography } from '@mui/material';
import { getCurrentTimezone, getTimezoneFullName, formatTimestampWithLocalTimezone } from 'utils/dateFormat';

interface TimestampDisplayProps {
  value: any;
  typographyProps?: React.ComponentProps<typeof Typography>;
}

// Renders a formatted timestamp where the timezone abbreviation (e.g. IST, EDT)
// shows a tooltip with the full timezone name on hover.
const TimestampDisplay = ({ value, typographyProps }: TimestampDisplayProps) => {
  const formatted = formatTimestampWithLocalTimezone(value);

  // Split on "(ABBR)" pattern to isolate the abbreviation for the tooltip
  const match = formatted.match(/^(.+)\(([^)]+)\)$/);

  if (!match) {
    return <Typography component="span" {...typographyProps}>{formatted}</Typography>;
  }

  const [, datePart, abbr] = match;
  const timezone = getCurrentTimezone();
  const fullName = getTimezoneFullName(timezone);

  return (
    <Typography component="span" {...typographyProps}>
      {datePart}
      <Tooltip title={fullName} arrow placement="top">
        <span style={{ cursor: 'default', borderBottom: '1px dotted currentColor' }}>
          ({abbr})
        </span>
      </Tooltip>
    </Typography>
  );
};

export default TimestampDisplay;
